import type { UserProps } from 'domains/user';

export const userInitialState = {
  brand: '',
  cycle: {
    currentCycle: 0,
    daysLeft: 0,
    daysTotal: 0,
    initialDate: '',
    finalDate: '',
    nextCycle: 0,
  },
  cycles: {
    cycles: [],
    canChooseCycle: false,
    canBuyOnlyInER: false,
    status: '',
    message: '',
  },
  fullAddress: '',
  isBlocked: false,
  isCeased: false,
  isMultiBrand: false,
  isWithdrawalCenter: false,
  name: '',
  region: '',
  resellerId: '',
  shippingModel: {
    availables: [],
    default: {
      code: 0,
      delivery: {
        address: '',
        distributionCenterCode: 0,
        distributionCenterName: '',
        isWithdrawalCenter: false,
      },
      name: '',
    },
  },
  supervisor: {
    name: '',
    contacts: [],
  },
  isExtendedCapitation: false,
  isResaleIntention: false,
  isAutoStartEnabled: false,
} as UserProps;
